import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard,
  Users,
  Building2,
  Truck,
  Package,
  ClipboardList,
  Factory,
  ClipboardCheck,
  AlertTriangle,
  LogOut,
  ChevronDown,
  Menu,
  X,
  FileText,
  Wrench,
  ShieldCheck,
  BookOpen,
  CalendarRange,
  Cog,
  Database,
  Shield,
  UserCheck,
  Grid3X3,
  GraduationCap,
  CalendarDays,
  BarChart3,
  FileCheck,
  TrendingUp,
  DollarSign,
  Briefcase,
  FileSpreadsheet,
  Mail,
  Award,
  ScrollText,
  Ruler,
  Gauge,
  Wallet,
  Warehouse,
  PenTool,
} from 'lucide-react';
import { cn } from '../lib/utils';

const sidebarConfig = [
  { type: 'link', name: 'Cruscotto', href: '/dashboard', icon: LayoutDashboard, roles: ['admin', 'quality', 'production', 'operator', 'management'] },
  {
    type: 'group', key: 'anagrafica', label: 'Anagrafica', icon: Database,
    roles: ['admin', 'quality', 'production', 'management'],
    children: [
      { name: 'Clienti', href: '/clients', icon: Building2, roles: ['admin', 'quality', 'production', 'management'] },
      { name: 'Fornitori', href: '/suppliers', icon: Truck, roles: ['admin', 'quality', 'production', 'management'] },
      { name: 'Certificazioni Fornitori', href: '/suppliers/certifications', icon: Award, roles: ['admin', 'quality', 'production', 'management'] },
      { name: 'Prodotti', href: '/products', icon: Package, roles: ['admin', 'quality', 'production', 'management'] },
      { name: 'Macchine', href: '/machines', icon: Cog, roles: ['admin', 'production', 'management', 'quality'] },
      { name: 'Dipendenti', href: '/employees', icon: UserCheck, roles: ['admin', 'production', 'management', 'quality'] },
    ],
  },
  {
    type: 'group', key: 'programmazione', label: 'Programmazione', icon: CalendarRange,
    roles: ['admin', 'quality', 'production', 'operator', 'management'],
    children: [
      { name: 'Ordini', href: '/orders', icon: ClipboardList, roles: ['admin', 'quality', 'production', 'management'] },
      { name: 'Vista Ordini per Prodotto', href: '/orders/product-matrix', icon: Grid3X3, roles: ['admin', 'quality', 'production', 'management'] },
      { name: 'Lotti di Produzione', href: '/production-lots', icon: Factory, roles: ['admin', 'quality', 'production', 'operator', 'management'] },
      { name: 'Pianificazione', href: '/planning', icon: CalendarDays, roles: ['admin', 'production', 'management', 'quality'] },
      { name: 'Progetti APQP/PPAP', href: '/apqp-projects', icon: Briefcase, roles: ['admin', 'quality', 'production', 'management'] },
      { name: 'Dashboard APQP', href: '/apqp-dashboard', icon: BarChart3, roles: ['admin', 'quality', 'production', 'management'] },
      { name: 'Manutenzione', href: '/maintenance', icon: Wrench, roles: ['admin', 'production', 'management', 'quality'] },
    ],
  },
  {
    type: 'group', key: 'spedizioni', label: 'Spedizioni', icon: Truck,
    roles: ['admin', 'quality', 'production', 'operator', 'management'],
    children: [
      { name: 'Calendario Spedizioni', href: '/shipment-calendar', icon: Truck, roles: ['admin', 'quality', 'production', 'management'] },
      { name: 'Registro Spedizioni', href: '/shipment-registry', icon: Package, roles: ['admin', 'quality', 'production', 'operator', 'management'] },
    ],
  },
  {
    type: 'group', key: 'qualita', label: 'Qualità', icon: Shield,
    roles: ['admin', 'quality', 'production', 'operator', 'management'],
    children: [
      { name: 'Dashboard QMS', href: '/qms-dashboard', icon: LayoutDashboard, roles: ['admin', 'quality', 'management'] },
      { name: 'Piani di Controllo Prodotto', href: '/qms-plans', icon: FileText, roles: ['admin', 'quality', 'production', 'operator', 'management'] },
      { name: 'Registro Controlli Qualità', href: '/quality-control-reports', icon: ClipboardCheck, roles: ['admin', 'quality', 'production', 'operator', 'management'] },
      { name: 'Controlli (Legacy)', href: '/qms-checks', icon: ClipboardCheck, roles: ['admin', 'quality', 'management'] },
      { name: 'Richiesta Produzione', href: '/qms-production-requests', icon: Wrench, roles: ['admin', 'quality', 'operator', 'management'] },
      { name: 'Registro Strumenti', href: '/instruments', icon: Ruler, roles: ['admin', 'quality', 'management'] },
      { name: 'NC Cliente Ricevute', href: '/customer-received-ncs', icon: AlertTriangle, roles: ['admin', 'quality', 'management'] },
      { name: 'Dashboard NC Cliente', href: '/customer-received-ncs/dashboard', icon: BarChart3, roles: ['admin', 'quality', 'management'] },
      { name: 'NC Fornitori', href: '/supplier-ncs', icon: AlertTriangle, roles: ['admin', 'quality', 'management'] },
      { name: 'Valutazione Fornitori', href: '/supplier-ncs/evaluation-dashboard', icon: BarChart3, roles: ['admin', 'quality', 'management'] },
      { name: 'Registro Scarti Interni', href: '/internal-scrap', icon: AlertTriangle, roles: ['admin', 'quality', 'production', 'management'] },
    ],
  },
  {
    type: 'group', key: 'formazione', label: 'Formazione', icon: GraduationCap,
    roles: ['admin', 'quality', 'production', 'management'],
    children: [
      { name: 'Matrix Competenze', href: '/skills-matrix', icon: Grid3X3, roles: ['admin', 'quality', 'production', 'management'] },
      { name: 'Calendario Corsi', href: '/training-calendar', icon: CalendarDays, roles: ['admin', 'quality', 'production', 'management'] },
      { name: 'Verbali Formazione', href: '/training-minutes', icon: FileCheck, roles: ['admin', 'quality', 'production', 'management'] },
      { name: 'Riepilogo Ore Formazione', href: '/training-summary', icon: BarChart3, roles: ['admin', 'quality', 'production', 'management'] },
    ],
  },
  {
    type: 'group', key: 'indicatori', label: 'Indicatori Aziendali', icon: TrendingUp,
    roles: ['admin', 'quality', 'production', 'management'],
    children: [
      { name: 'Dashboard KPI', href: '/kpi-dashboard', icon: BarChart3, roles: ['admin', 'quality', 'production', 'management'] },
      { name: 'Analisi Fatturato', href: '/indicator-revenue', icon: DollarSign, roles: ['admin', 'quality', 'management'] },
      { name: 'Impatto Personale', href: '/indicator-personnel', icon: Users, roles: ['admin', 'quality', 'management'] },
      { name: 'NC Cliente', href: '/indicator-nc-customer', icon: AlertTriangle, roles: ['admin', 'quality', 'production', 'management'] },
      { name: 'Scarti Interni', href: '/indicator-scrap', icon: Factory, roles: ['admin', 'quality', 'production', 'management'] },
    ],
  },
  {
    type: 'group', key: 'commerciale', label: 'Commerciale', icon: Briefcase,
    roles: ['admin', 'quality', 'production', 'management'],
    children: [
      { name: 'Registro Offerte', href: '/commercial-offers', icon: FileSpreadsheet, roles: ['admin', 'quality', 'production', 'management'] },
      { name: 'Cruscotto Commerciale', href: '/commercial-dashboard', icon: BarChart3, roles: ['admin', 'quality', 'management'] },
      ...(process.env.REACT_APP_ENABLE_TREASURY === 'true'
        ? [{ name: 'Tesoreria', href: '/treasury', icon: Wallet, roles: ['admin', 'management'] }]
        : []),
    ],
  },
  {
    type: 'group', key: 'gestione', label: 'Gestione', icon: Cog,
    roles: ['admin', 'quality', 'production', 'operator', 'management'],
    children: [
      { name: 'Utenti', href: '/users', icon: Users, roles: ['admin'] },
      { name: 'Impostazioni Mail', href: '/email-settings', icon: Mail, roles: ['admin'] },
      { name: 'Firma QA', href: '/qa-signature-settings', icon: PenTool, roles: ['admin', 'quality'] },
      { name: 'Manuale', href: '/manuale', icon: BookOpen, roles: ['admin', 'quality', 'production', 'operator', 'management'] },
      { name: 'Audit Trail', href: '/audit-trail', icon: ScrollText, roles: ['admin', 'quality', 'management'] },
      { name: 'Reset Ambiente', href: '/environment-reset', icon: AlertTriangle, roles: ['admin'] },
    ],
  },
];

// Flatten all links for the header title lookup
const allLinks = sidebarConfig.flatMap(item =>
  item.type === 'group' ? item.children : [item]
);

export const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [expanded, setExpanded] = useState(() => {
    // Auto-expand section containing the current active page
    const init = {};
    sidebarConfig.forEach(item => {
      if (item.type === 'group') {
        const hasActive = item.children.some(c =>
          location.pathname === c.href || (c.href !== '/dashboard' && location.pathname.startsWith(c.href))
        );
        init[item.key] = hasActive;
      }
    });
    return init;
  });

  const toggleSection = (key) => setExpanded(prev => ({ ...prev, [key]: !prev[key] }));

  const isLinkActive = (href) =>
    location.pathname === href || (href !== '/dashboard' && location.pathname.startsWith(href));

  const currentPage = allLinks.find(item => isLinkActive(item.href));

  const userRole = user?.role || '';

  return (
    <div className="min-h-screen bg-slate-50" data-testid="app-layout">
      {sidebarOpen && (
        <div className="fixed inset-0 z-40 bg-black/50 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      <aside
        className={cn(
          "fixed inset-y-0 left-0 z-50 w-64 bg-slate-900 transform transition-transform duration-200 ease-in-out lg:translate-x-0 flex flex-col",
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        )}
        data-testid="sidebar"
      >
        {/* Logo */}
        <div className="flex items-center justify-between h-16 px-4 border-b border-slate-800 flex-shrink-0">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center">
              <Factory className="w-5 h-5 text-white" />
            </div>
            <span className="text-white font-semibold text-lg tracking-tight">Internal ERP</span>
          </Link>
          <button className="lg:hidden text-slate-400 hover:text-white" onClick={() => setSidebarOpen(false)}>
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto" data-testid="nav-menu">
          {sidebarConfig.map((item) => {
            if (item.type === 'link') {
              if (!item.roles.includes(userRole)) return null;
              const active = isLinkActive(item.href);
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  data-testid={`nav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
                  className={cn(
                    "flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors",
                    active ? "bg-slate-800 text-white" : "text-slate-400 hover:text-white hover:bg-slate-800/50"
                  )}
                  onClick={() => setSidebarOpen(false)}
                >
                  <item.icon className="w-[18px] h-[18px] flex-shrink-0" />
                  {item.name}
                </Link>
              );
            }

            if (item.type === 'group') {
              if (!item.roles.includes(userRole)) return null;
              const visibleChildren = item.children.filter(c => c.roles.includes(userRole));
              if (visibleChildren.length === 0) return null;
              const isOpen = expanded[item.key];
              const hasActiveChild = visibleChildren.some(c => isLinkActive(c.href));

              return (
                <div key={item.key} className="pt-1">
                  <button
                    onClick={() => toggleSection(item.key)}
                    data-testid={`nav-group-${item.key}`}
                    className={cn(
                      "flex items-center gap-3 w-full px-3 py-2 rounded-lg text-sm font-medium transition-colors",
                      hasActiveChild ? "text-white" : "text-slate-400 hover:text-white hover:bg-slate-800/50"
                    )}
                  >
                    <item.icon className="w-[18px] h-[18px] flex-shrink-0" />
                    <span className="flex-1 text-left">{item.label}</span>
                    <ChevronDown className={cn(
                      "w-4 h-4 transition-transform duration-200",
                      isOpen ? "rotate-0" : "-rotate-90"
                    )} />
                  </button>
                  <div className={cn(
                    "overflow-hidden transition-all duration-200",
                    isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                  )}>
                    <div className="ml-4 pl-3 border-l border-slate-700/50 space-y-0.5 py-1">
                      {visibleChildren.map(child => {
                        const childActive = isLinkActive(child.href);
                        return (
                          <Link
                            key={child.href}
                            to={child.href}
                            data-testid={`nav-${child.name.toLowerCase().replace(/\s+/g, '-')}`}
                            className={cn(
                              "flex items-center gap-2.5 px-3 py-1.5 rounded-md text-[13px] font-medium transition-colors",
                              childActive ? "bg-slate-800 text-white" : "text-slate-500 hover:text-white hover:bg-slate-800/50"
                            )}
                            onClick={() => setSidebarOpen(false)}
                          >
                            <child.icon className="w-4 h-4 flex-shrink-0" />
                            {child.name}
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            }
            return null;
          })}
        </nav>

        {/* User Info */}
        <div className="p-3 border-t border-slate-800 flex-shrink-0">
          <div className="flex items-center gap-3 px-3 py-2">
            <div className="w-8 h-8 bg-slate-700 rounded-full flex items-center justify-center">
              <span className="text-sm font-medium text-white">
                {user?.first_name?.[0]}{user?.last_name?.[0]}
              </span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-white truncate">{user?.first_name} {user?.last_name}</p>
              <p className="text-xs text-slate-400 capitalize">{user?.role}</p>
            </div>
            <button
              onClick={logout}
              className="p-1.5 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg transition-colors"
              data-testid="logout-btn"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <div className="lg:pl-64">
        <header className="sticky top-0 z-30 bg-white/90 backdrop-blur-md border-b border-slate-200" data-testid="header">
          <div className="flex items-center justify-between h-16 px-4 lg:px-6">
            <div className="flex items-center gap-4">
              <button
                className="lg:hidden p-2 text-slate-600 hover:bg-slate-100 rounded-lg"
                onClick={() => setSidebarOpen(true)}
                data-testid="mobile-menu-btn"
              >
                <Menu className="w-5 h-5" />
              </button>
              <h1 className="text-lg font-semibold text-slate-900 hidden sm:block">
                {currentPage?.name || 'Cruscotto'}
              </h1>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-xs text-slate-500 font-mono hidden md:block">ERP v1.0</span>
            </div>
          </div>
        </header>

        <main className="p-4 lg:p-6">
          <div className="animate-fade-in">{children}</div>
        </main>
      </div>
    </div>
  );
};
